import { Event_ } from '../Event_';
export class WheelEvent_ extends Event_ {
    get isWheelUp() {
        return this.reactEvent.deltaY < 0;
    }
    get isWheelDown() {
        return this.reactEvent.deltaY > 0;
    }
}
